import Resource from '@/api/resource';

class TransactionResource extends Resource {
  constructor() {
    super('admin/transactions');
  }
}

export { TransactionResource as default };
